export default {
  'comingsoon': 'This feature is coming soon!',
  'Account': 'Account',
  'Connect': 'Connect',
  'Disconnect': 'Disconnect',
  'Already with an account?': 'Already with an account?',
  'Blog': 'Blog',
  'Change profile picture': 'Change profile picture',
  'confirmed': 'confirmed',
  'Consent': 'Consent',
  'copy': 'Copy',
  'Copy': 'Copy',
  'Community': 'Community',
  'Decline': 'Decline',
  'Email': 'Email',
  'Firstname': 'Firstname',
  'Help Center': 'Help Center',
  'Home': 'Home',
  'Imprint': 'Imprint',
  'Lastname': 'Lastname',
  'Learning': 'Learning',
  'login': 'Login',
  'Login': 'Login',
  'logout': 'Logout',
  'Logout': 'Logout',
  'password': 'Password',
  'Password': 'Password',
  'Pricing': 'Pricing',
  'privacy': 'privacy',
  'Privacy': 'Privacy',
  'profile': 'Profile',
  'Profile': 'Profile',
  'Read more': 'Read more',
  'Register': 'Register',
  'Report a bug': 'Report a bug',
  'Remove': 'Remove',
  'School': 'School',
  'Settings': 'Settings',
  'Search': 'Search',
  'Filter categories': 'Filter categories',
  'Simulator': 'Simulator',
  'Courses': 'Courses',
  'Submit': 'Submit',
  'Subscription': 'Subscription',
  'Cancel subscription': 'Cancel subscription',
  'Resume subscription': 'Resume subscription',
  'tos': 'Terms of Service',
  'Wiki': 'Wiki',
  'Write': 'Write',
  'Send': 'Send',
  'Total': 'Total',
  'Seen': 'Seen',
  'Positive': 'Positive',
  'Catalogs': 'Catalogs',
  'Question': 'Question',
  'per': 'per',
  'month': 'month',
  'Month': 'Month',
  'Monthly': 'Monthly',
  'Year': 'Year',
  'Yearly': 'Yearly',
  'Examples': 'Examples',
  'Flightschool': 'Flight School',
  'Your Name': 'Your Name',
  'Phone': 'Phone',
  'Request': 'Request',
  'privacyagreement': 'I agree to the data protection agreement and the terms of service.',
  'Questions': 'Questions',
  'Lections': 'Lections',
  'Scenarios': 'Scenarios',
  'Spelling': 'Spelling',
  'Listening': 'Listening',
  'Tos': 'Terms of Service',
  'Tools': 'Tools',
  'Username': 'Username',
  'username': 'username',
  'Show hint again': 'Show hint again',
  'Mark as read': 'Mark as read',
}
